/** Gets percentage of the value */
export function percentageOfValue(value: number, percent: number): number {
  return (value / 100) * percent;
}
